import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * Static demo rows for Bills table (markup only, no API).
 * Matches design: file, status, allocation, Appfolio, utilities, properties, account, etc.
 */

import { getUtilityLabel } from './billsFilters';

/** Where a bill entered the system. Bills uploaded from this page are always "Bills Dashboard". */
export const BILL_SOURCES = {
  api: 'API',
  billsDashboard: 'Bills Dashboard',
  email: 'Email',
  propertyAllocation: 'Property Allocation'
};

/**
 * A fixed spread of sources across the demo rows. Drawing them at random would reshuffle the column
 * on every render and break sorting, so the mix is varied but stable.
 */
const DEMO_BILL_SOURCE_ROTATION = [BILL_SOURCES.propertyAllocation, BILL_SOURCES.email, BILL_SOURCES.billsDashboard, BILL_SOURCES.api, BILL_SOURCES.propertyAllocation, BILL_SOURCES.email, BILL_SOURCES.api];
const addressLine = '2608 Bravado Dr, Rancho Cordova, CA 95670';
const DEMO_BILL_ROWS = [{
  id: 'bill-demo-1',
  fileName: 'bill_sample.pdf',
  status: 'Extracted',
  allocation: {
    done: 6,
    total: 8
  },
  appfolioPush: {
    done: 6,
    total: 8
  },
  utilityIcons: ['water', 'electricity', 'trash', 'sewer'],
  propertiesLines: [addressLine, addressLine],
  account: 'Rancho Cordova Portfolio',
  provider: 'HARBOR BAY UTILITIES',
  servicePeriod: '13/01/20 - 11/02/20',
  days: 30,
  amount: 4158.74,
  invoiceNumber: 'HBU-4839202175-1',
  dueDate: '03/12/20',
  dateUploaded: '03/12/20'
}, {
  id: 'bill-demo-2',
  fileName: 'utility_march_2026.pdf',
  status: 'Pending',
  allocation: {
    done: 2,
    total: 5
  },
  appfolioPush: {
    done: 0,
    total: 5
  },
  utilityIcons: ['electricity', 'sewer'],
  propertiesLines: ['1200 Market St, San Francisco, CA 94102'],
  account: 'Bay Area Portfolio',
  provider: 'PACIFIC GAS & ELECTRIC',
  servicePeriod: '01/03/26 - 31/03/26',
  days: 31,
  amount: 12840.5,
  invoiceNumber: 'PGE-992831-44',
  dueDate: '15/04/26',
  dateUploaded: '02/04/26'
}, {
  id: 'bill-demo-3',
  fileName: 'water_statement_q1.pdf',
  status: 'Extracted',
  allocation: {
    done: 8,
    total: 8
  },
  appfolioPush: {
    done: 8,
    total: 8
  },
  utilityIcons: ['water', 'trash'],
  propertiesLines: ['88 Lakeview Ave, Oakland, CA 94610', '90 Lakeview Ave, Oakland, CA 94610'],
  account: 'East Bay Holdings',
  provider: 'EAST BAY MUD',
  servicePeriod: '01/01/26 - 31/03/26',
  days: 90,
  amount: 672.0,
  invoiceNumber: 'EBM-4400219',
  dueDate: '30/04/26',
  dateUploaded: '28/03/26'
}, {
  id: 'bill-demo-4',
  fileName: 'gas_usage_feb.pdf',
  status: 'Extracted',
  allocation: {
    done: 4,
    total: 6
  },
  appfolioPush: {
    done: 3,
    total: 6
  },
  utilityIcons: ['sewer', 'electricity'],
  propertiesLines: ['400 Capitol Mall, Sacramento, CA 95814'],
  account: 'Capital City REIT',
  provider: 'SACRAMENTO MUNICIPAL UTILITY',
  servicePeriod: '01/02/26 - 28/02/26',
  days: 28,
  amount: 2341.88,
  invoiceNumber: 'SMUD-77812004',
  dueDate: '20/03/26',
  dateUploaded: '05/03/26'
}, {
  id: 'bill-demo-5',
  fileName: 'combined_utilities_jan.pdf',
  status: 'Pending',
  allocation: {
    done: 1,
    total: 10
  },
  appfolioPush: {
    done: 0,
    total: 10
  },
  utilityIcons: ['water', 'electricity', 'trash', 'sewer'],
  propertiesLines: ['15 Main St, Davis, CA 95616', '17 Main St, Davis, CA 95616'],
  account: 'Yolo Property Partners',
  provider: 'VALLEY CLEAN ENERGY',
  servicePeriod: '01/01/26 - 31/01/26',
  days: 31,
  amount: 5092.15,
  invoiceNumber: 'VCE-3309281-7',
  dueDate: '10/03/26',
  dateUploaded: '01/03/26'
}, {
  id: 'bill-demo-6',
  fileName: 'trash_recycling_q1.pdf',
  status: 'Extracted',
  allocation: {
    done: 8,
    total: 8
  },
  appfolioPush: {
    done: 7,
    total: 8
  },
  utilityIcons: ['trash', 'sewer'],
  propertiesLines: ['2200 Broadway, Oakland, CA 94612'],
  account: 'East Bay Holdings',
  provider: 'WASTE MANAGEMENT NORCAL',
  servicePeriod: '01/01/26 - 31/03/26',
  days: 90,
  amount: 1189.0,
  invoiceNumber: 'WMN-88291003',
  dueDate: '25/04/26',
  dateUploaded: '22/03/26'
}, {
  id: 'bill-demo-7',
  fileName: 'electric_april_estate.pdf',
  status: 'Failed',
  allocation: {
    done: 0,
    total: 4
  },
  appfolioPush: {
    done: 0,
    total: 4
  },
  utilityIcons: ['electricity'],
  propertiesLines: ['1 Embarcadero, San Francisco, CA 94111'],
  account: 'Bay Area Portfolio',
  provider: 'PACIFIC GAS & ELECTRIC',
  servicePeriod: '01/04/26 - 30/04/26',
  days: 30,
  amount: 22100.0,
  invoiceNumber: 'PGE-992900-01',
  dueDate: '18/05/26',
  dateUploaded: '10/04/26'
}, {
  id: 'bill-demo-8',
  fileName: 'water_sewer_march.pdf',
  status: 'Extracted',
  allocation: {
    done: 5,
    total: 5
  },
  appfolioPush: {
    done: 5,
    total: 5
  },
  utilityIcons: ['water', 'trash'],
  propertiesLines: ['500 First St, Napa, CA 94559'],
  account: 'Wine Country Rentals LLC',
  provider: 'CITY OF NAPA UTILITIES',
  servicePeriod: '01/03/26 - 31/03/26',
  days: 31,
  amount: 445.67,
  invoiceNumber: 'NAPA-U-44021',
  dueDate: '05/05/26',
  dateUploaded: '02/04/26'
}, {
  id: 'bill-demo-9',
  fileName: 'multi_meter_bundle.pdf',
  status: 'Pending',
  allocation: {
    done: 6,
    total: 12
  },
  appfolioPush: {
    done: 4,
    total: 12
  },
  utilityIcons: ['electricity', 'water', 'sewer'],
  propertiesLines: ['100 Pine St, San Francisco, CA 94108', '102 Pine St, San Francisco, CA 94108'],
  account: 'SF Downtown Holdings',
  provider: 'PACIFIC GAS & ELECTRIC',
  servicePeriod: '15/02/26 - 14/03/26',
  days: 29,
  amount: 18765.33,
  invoiceNumber: 'PGE-88392011',
  dueDate: '12/04/26',
  dateUploaded: '28/03/26'
}, {
  id: 'bill-demo-10',
  fileName: 'harbor_bay_may.pdf',
  status: 'Extracted',
  allocation: {
    done: 3,
    total: 8
  },
  appfolioPush: {
    done: 3,
    total: 8
  },
  utilityIcons: ['water', 'electricity', 'trash', 'sewer'],
  propertiesLines: [addressLine],
  account: 'Rancho Cordova Portfolio',
  provider: 'HARBOR BAY UTILITIES',
  servicePeriod: '01/05/26 - 31/05/26',
  days: 31,
  amount: 3980.12,
  invoiceNumber: 'HBU-4839202200-2',
  dueDate: '28/06/26',
  dateUploaded: '03/06/26'
}, {
  id: 'bill-demo-11',
  fileName: 'ebmud_statement_apr.pdf',
  status: 'Extracted',
  allocation: {
    done: 7,
    total: 7
  },
  appfolioPush: {
    done: 6,
    total: 7
  },
  utilityIcons: ['water'],
  propertiesLines: ['44 College Ave, Berkeley, CA 94705'],
  account: 'East Bay Holdings',
  provider: 'EAST BAY MUD',
  servicePeriod: '01/04/26 - 30/04/26',
  days: 30,
  amount: 923.45,
  invoiceNumber: 'EBM-4400991',
  dueDate: '22/05/26',
  dateUploaded: '18/04/26'
}, {
  id: 'bill-demo-12',
  fileName: 'landscaping_irrigation.pdf',
  status: 'Pending',
  allocation: {
    done: 2,
    total: 6
  },
  appfolioPush: {
    done: 1,
    total: 6
  },
  utilityIcons: ['water', 'sewer'],
  propertiesLines: ['900 Roseville Pkwy, Roseville, CA 95678'],
  account: 'Capital City REIT',
  provider: 'PLACER COUNTY WATER AGENCY',
  servicePeriod: '01/03/26 - 31/03/26',
  days: 31,
  amount: 1567.2,
  invoiceNumber: 'PCWA-772910',
  dueDate: '30/04/26',
  dateUploaded: '25/03/26'
}, {
  id: 'bill-demo-13',
  fileName: 'storm_drain_fee.pdf',
  status: 'Extracted',
  allocation: {
    done: 8,
    total: 8
  },
  appfolioPush: {
    done: 8,
    total: 8
  },
  utilityIcons: ['trash', 'water'],
  propertiesLines: ['2500 Fair Oaks Blvd, Carmichael, CA 95608'],
  account: 'Rancho Cordova Portfolio',
  provider: 'SACRAMENTO COUNTY REGIONAL SANITATION',
  servicePeriod: '01/01/26 - 31/03/26',
  days: 90,
  amount: 312.0,
  invoiceNumber: 'SCR-991002',
  dueDate: '15/05/26',
  dateUploaded: '10/04/26'
}, {
  id: 'bill-demo-14',
  fileName: 'pge_backup_account.pdf',
  status: 'Pending',
  allocation: {
    done: 4,
    total: 9
  },
  appfolioPush: {
    done: 2,
    total: 9
  },
  utilityIcons: ['electricity', 'sewer'],
  propertiesLines: ['555 California St, San Francisco, CA 94104'],
  account: 'Bay Area Portfolio',
  provider: 'PACIFIC GAS & ELECTRIC',
  servicePeriod: '01/02/26 - 28/02/26',
  days: 28,
  amount: 9543.0,
  invoiceNumber: 'PGE-772831-09',
  dueDate: '25/03/26',
  dateUploaded: '01/03/26'
}, {
  id: 'bill-demo-15',
  fileName: 'commercial_water_bulk.pdf',
  status: 'Failed',
  allocation: {
    done: 0,
    total: 8
  },
  appfolioPush: {
    done: 0,
    total: 8
  },
  utilityIcons: ['water', 'electricity'],
  propertiesLines: ['2000 Maritime St, Oakland, CA 94607'],
  account: 'East Bay Holdings',
  provider: 'EAST BAY MUD',
  servicePeriod: '01/05/26 - 31/05/26',
  days: 31,
  amount: 12440.0,
  invoiceNumber: 'EBM-4401100',
  dueDate: '30/06/26',
  dateUploaded: '05/06/26'
}, {
  id: 'bill-demo-16',
  fileName: 'street_lighting_assessment.pdf',
  status: 'Extracted',
  allocation: {
    done: 6,
    total: 6
  },
  appfolioPush: {
    done: 5,
    total: 6
  },
  utilityIcons: ['electricity'],
  propertiesLines: ['3300 J St, Sacramento, CA 95816'],
  account: 'Capital City REIT',
  provider: 'SACRAMENTO MUNICIPAL UTILITY',
  servicePeriod: '01/04/26 - 30/04/26',
  days: 30,
  amount: 890.11,
  invoiceNumber: 'SMUD-77813088',
  dueDate: '18/05/26',
  dateUploaded: '12/04/26'
}, {
  id: 'bill-demo-17',
  fileName: 'vce_tou_meter.pdf',
  status: 'Extracted',
  allocation: {
    done: 9,
    total: 10
  },
  appfolioPush: {
    done: 8,
    total: 10
  },
  utilityIcons: ['electricity', 'water'],
  propertiesLines: ['800 Richards Blvd, Sacramento, CA 95811'],
  account: 'Yolo Property Partners',
  provider: 'VALLEY CLEAN ENERGY',
  servicePeriod: '01/06/26 - 30/06/26',
  days: 30,
  amount: 3321.67,
  invoiceNumber: 'VCE-3310002-1',
  dueDate: '28/07/26',
  dateUploaded: '02/07/26'
}, {
  id: 'bill-demo-18',
  fileName: 'waste_roll_off_feb.pdf',
  status: 'Pending',
  allocation: {
    done: 3,
    total: 5
  },
  appfolioPush: {
    done: 2,
    total: 5
  },
  utilityIcons: ['trash', 'sewer'],
  propertiesLines: ['1600 Amphitheatre Pkwy, Mountain View, CA 94043'],
  account: 'SF Downtown Holdings',
  provider: 'WASTE MANAGEMENT NORCAL',
  servicePeriod: '01/02/26 - 28/02/26',
  days: 28,
  amount: 2890.0,
  invoiceNumber: 'WMN-88291122',
  dueDate: '20/03/26',
  dateUploaded: '15/02/26'
}, {
  id: 'bill-demo-19',
  fileName: 'napa_irrigation_adjust.pdf',
  status: 'Extracted',
  allocation: {
    done: 8,
    total: 8
  },
  appfolioPush: {
    done: 8,
    total: 8
  },
  utilityIcons: ['water', 'sewer'],
  propertiesLines: ['1200 Trancas St, Napa, CA 94558'],
  account: 'Wine Country Rentals LLC',
  provider: 'CITY OF NAPA UTILITIES',
  servicePeriod: '01/05/26 - 31/05/26',
  days: 31,
  amount: 612.34,
  invoiceNumber: 'NAPA-U-44102',
  dueDate: '15/06/26',
  dateUploaded: '08/06/26'
}, {
  id: 'bill-demo-20',
  fileName: 'year_end_true_up.pdf',
  status: 'Pending',
  allocation: {
    done: 1,
    total: 20
  },
  appfolioPush: {
    done: 0,
    total: 20
  },
  utilityIcons: ['water', 'electricity', 'trash', 'sewer'],
  propertiesLines: ['1 Ferry Building, San Francisco, CA 94111', '5 Ferry Building, San Francisco, CA 94111'],
  account: 'Bay Area Portfolio',
  provider: 'PACIFIC GAS & ELECTRIC',
  servicePeriod: '01/01/25 - 31/12/25',
  days: 365,
  amount: 45220.99,
  invoiceNumber: 'PGE-YE-2025-001',
  dueDate: '30/06/26',
  dateUploaded: '01/04/26'
}];
export const DEMO_BILLS = DEMO_BILL_ROWS.map((bill, index) => _objectSpread(_objectSpread({}, bill), {}, {
  billSource: DEMO_BILL_SOURCE_ROTATION[index % DEMO_BILL_SOURCE_ROTATION.length],
  utilityTypes: bill.utilityIcons.map(getUtilityLabel)
}));